module.exports = __webpack_public_path__ + "static/media/pla_rol_over_pro.6b946550.png";